
import React from "react";
import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";

type ChatSearchBarProps = {
  searchQuery: string;
  onSearchChange: (value: string) => void;
};

const ChatSearchBar = ({ searchQuery, onSearchChange }: ChatSearchBarProps) => {
  return (
    <div className="relative w-full">
      <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-muted-foreground" />
      <Input
        value={searchQuery}
        onChange={(e) => onSearchChange(e.target.value)}
        placeholder="Search messages"
        className="w-full pl-9 h-10 bg-muted/40"
      />
    </div>
  );
};

export default ChatSearchBar;
